import { ButtonType } from '@thiememeulenhoff/types';
import { html, nothing } from 'lit';
import { property } from 'lit/decorators.js';
import { FocusOptions } from '@angular/cdk/a11y';
import { TmElement } from '../../custom-element.helper';

export abstract class AnchorElement extends TmElement {
  @property({ type: String })
  href?: string;

  @property({ type: String })
  target?: string;

  @property({ type: Boolean })
  disabled = false;

  @property({ type: String })
  type: ButtonType = 'button';

  constructor() {
    super();
    this.attachShadow({ mode: 'open', delegatesFocus: true });

    this.listen('click', (event: Event) => {
      if (this.disabled) {
        event.preventDefault();
        event.stopPropagation();

        return;
      }

      this.handleClick(event as MouseEvent);
    });
  }

  protected onSlotChanged() {
    // Can be overwritten
  }

  override render() {
    if (this.href) {
      return html`<a
        part="button"
        class="button"
        href=${this.disabled ? nothing : this.href}
        target=${this.target ?? nothing}
        ?disabled=${this.disabled}
        data-test="anchor"
        aria-label="${this.ariaLabel || nothing}"
      >
        <slot @slotchange=${this.onSlotChanged}></slot>
      </a>`;
    }

    return html`<button
      part="button"
      class="button"
      ?disabled=${this.disabled}
      type=${this.type}
      data-test="button"
      aria-label="${this.ariaLabel || nothing}"
    >
      <slot @slotchange=${this.onSlotChanged}></slot>
    </button>`;
  }

  /**
   * @deprecated `clicked` event is deprecated, use `click` event instead
   */
  handleClick = (event: MouseEvent) => {
    this.dispatchLocalEvent({
      eventName: 'clicked',
      detail: event,
    });
  };

  override focus(options?: FocusOptions) {
    super.focus(options);

    setTimeout(() => {
      this.shadowRoot?.querySelector<HTMLElement>('.button')?.focus();
    }, 100);
  }
}
